<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "WidgetsPage",
};
</script>

<style scoped lang="scss"></style>
